import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgSorting(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8537 20.3536L20.0357 17.1716C20.2309 16.9763 20.2309 16.6597 20.0357 16.4645C19.8404 16.2692 19.5238 16.2692 19.3286 16.4645L17.0001 18.7929L17.0001 8C17.0001 7.72386 16.7763 7.5 16.5001 7.5C16.224 7.5 16.0001 7.72386 16.0001 8L16.0001 18.7929L13.6717 16.4645C13.4765 16.2692 13.1599 16.2692 12.9646 16.4645C12.7694 16.6597 12.7694 16.9763 12.9646 17.1716L16.1466 20.3536C16.3419 20.5488 16.6584 20.5488 16.8537 20.3536ZM7.14659 3.64645L3.96461 6.82843C3.76935 7.02369 3.76935 7.34027 3.96461 7.53553C4.15988 7.7308 4.47646 7.7308 4.67172 7.53553L7.00015 5.20711L7.00015 16C7.00015 16.2761 7.22401 16.5 7.50015 16.5C7.77629 16.5 8.00015 16.2761 8.00015 16L8.00015 5.20711L10.3286 7.53553C10.5238 7.7308 10.8404 7.7308 11.0357 7.53553C11.2309 7.34027 11.2309 7.02369 11.0357 6.82843L7.8537 3.64645C7.65844 3.45118 7.34186 3.45118 7.14659 3.64645Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSorting);

var SortingOutline = forwardRef((props, ref) => jsx(ForwardRef, Object.assign({
  ref: ref
}, props)));

export { SortingOutline as default };
